import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { EnvironmentService } from '../environment/environment.service';
import * as i0 from "@angular/core";
import * as i1 from "../environment/environment.service";
import * as i2 from "@angular/common/http";
import * as i3 from "@angular/platform-browser";
var sessionApiUrl = "/validateSession";
var sessionUpdateApiUrl = "/update-session";
var SessionService = /** @class */ (function () {
    function SessionService(environmentService, http, sanitizer) {
        this.environmentService = environmentService;
        this.http = http;
        this.sanitizer = sanitizer;
        this.isSessionExpired = false;
        this.apiUrl = this.environmentService.envModel.appSettings.apiUrlSession;
        this.sessionState = this.environmentService.envModel.sessionState;
        this.authKey = this.environmentService.envModel.authSettings.authKey;
    }
    SessionService.prototype.setSessionState = function (state) {
        sessionStorage.setItem(this.sessionState, state);
    };
    SessionService.prototype.setToken = function (token) {
        if (!token)
            return false;
        localStorage.setItem(this.authKey, token);
        return true;
    };
    SessionService.prototype.retrieveToken = function () {
        return localStorage.getItem(this.authKey);
    };
    SessionService.prototype.removeToken = function () {
        localStorage.removeItem(this.authKey);
    };
    SessionService.prototype.verifySessionState = function () {
        if (!sessionStorage.getItem(this.sessionState) || sessionStorage.getItem(this.sessionState) == 'false')
            return false;
        return true;
    };
    SessionService.prototype.getSessionState = function (jwt, idConexao) {
        var URL = this.apiUrl + sessionApiUrl;
        var headers = new HttpHeaders({ jwt: jwt, id_conexao: idConexao });
        return this.http.get(URL, { headers: headers });
    };
    SessionService.prototype.updateSession = function () {
        return this.http.get(this.apiUrl + sessionUpdateApiUrl, { responseType: 'text' });
    };
    SessionService.prototype.expireSession = function () {
        this.setSessionState('false');
        this.isSessionExpired = true;
        this.removeToken();
        this.removeAuthUser();
        this.clearPermissionsFromStorage();
    };
    /**
     * Remove a chave 'en4-permissions' do sessionStorage
     * Centraliza a limpeza de dados sensiveis de permissao
     * Nota: O hash SHA-256 e armazenado apenas em memoria no PermissionService
     */
    SessionService.prototype.clearPermissionsFromStorage = function () {
        sessionStorage.removeItem('en4-permissions');
    };
    SessionService.prototype.timeoutSession = function () {
        if (this.verifySessionState()) {
            this.expireSession();
        }
    };
    SessionService.prototype.getSafeUrl = function (url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    SessionService.prototype.getAuthUser = function () {
        return JSON.parse(localStorage.getItem('authUser'));
    };
    SessionService.prototype.setAuthUser = function (authUser) {
        localStorage.setItem('authUser', JSON.stringify(authUser));
    };
    SessionService.prototype.removeAuthUser = function () {
        localStorage.removeItem('authUser');
    };
    SessionService.prototype.isUserLogged = function () {
        var token = this.retrieveToken();
        var authUser = this.getAuthUser();
        if (!token || token === '' || authUser == null)
            return false;
        return true;
    };
    SessionService.ngInjectableDef = i0.defineInjectable({ factory: function SessionService_Factory() { return new SessionService(i0.inject(i1.EnvironmentService), i0.inject(i2.HttpClient), i0.inject(i3.DomSanitizer)); }, token: SessionService, providedIn: "root" });
    return SessionService;
}());
export { SessionService };
